import type { RouteRecordRaw } from 'vue-router'
import IconQuestionnaires from '@/components/icons/IconQuestionnaires.vue'

const professionalHomeRoutesNames = {
  professionalHomePage: 'professionalHomePage',
  professionalHomeQuestionnaires: 'professionalHomeQuestionnaires',
  professionalHomeFeedbackList: 'professionalHomeFeedbackList',
  professionalHomeStudents: 'professionalHomeStudents'
}

const professionalRoutesNames = {
  professionalQuestionnaires: 'professionalQuestionnaires',
  professionalQuestionnaireDomains: 'professionalQuestionnaireDomains',
  professionalQuestionnaireQuestions: 'professionalQuestionnaireQuestions',
  professionalStudents: 'professionalStudents',
  professionalFeedbackList: 'professionalFeedbackList',
  professionalAddFeedback: 'professionalAddFeedback',
  professionalDirectoryList: 'professionalDirectoryList',
  professionalGroups: 'professionalGroups',
  professionalGroupStudents: 'professionalGroupStudents',
  ...professionalHomeRoutesNames
}

const home: RouteRecordRaw =
{
  path: 'home',
  name: professionalHomeRoutesNames.professionalHomePage,
  meta: {
    label: 'Home',
    icon: PhDatabase
  },
  redirect: { name: professionalHomeRoutesNames.professionalHomeQuestionnaires },
  component: () => import('@/layouts/RouterTabsLayout.vue'),
  children: [
    {
      path: 'questionnaires',
      name: professionalHomeRoutesNames.professionalHomeQuestionnaires,
      meta: {
        parentName: professionalHomeRoutesNames.professionalHomePage,
        label: 'Questionnaires',
        icon: IconQuestionnaires
      },
      component: () => import('@/features/questionnaires/QuestionnairesList.vue')
    },
    {
      path: 'feedback',
      name: professionalHomeRoutesNames.professionalHomeFeedbackList,
      meta: {
        parentName: professionalHomeRoutesNames.professionalHomePage,
        label: 'Feedback',
        icon: PhListPlus
      },
      component: () => import('@/features/feedback/FeedbackHomeList.vue')
    },
    {
      path: 'students',
      name: professionalHomeRoutesNames.professionalHomeStudents,
      meta: {
        parentName: professionalHomeRoutesNames.professionalHomePage,
        label: 'Students',
        icon: PhStudent
      },
      component: () => import('@/features/students/StudentsList.vue')
    }
  ]
}

const professionalRoutes: RouteRecordRaw[] = [
  home,
  {
    path: 'questionnaires',
    name: professionalRoutesNames.professionalQuestionnaires,
    meta: {
      label: 'Questionnaires',
      icon: IconQuestionnaires,
      routeTestId: 'professional-questionnaires-route-btn'
    },
    component: () => import('@/features/questionnaires/QuestionnairesList.vue')
  },
  {
    path: 'questionnaires/:id/domains',
    name: professionalRoutesNames.professionalQuestionnaireDomains,
    meta: {
      parentName: professionalRoutesNames.professionalQuestionnaires,
      notRenderInSidebar: true
    },
    component: () => import('@/features/questionnaires/QuestionnaireDomainList.vue')
  },
  {
    path: 'questionnaires/:id/domains/:domainId',
    name: professionalRoutesNames.professionalQuestionnaireQuestions,
    meta: {
      parentName: professionalRoutesNames.professionalQuestionnaires,
      notRenderInSidebar: true
    },
    component: () => import('@/features/questionnaires/QuestionnairesQuestionsStepper.vue')
  },
  {
    path: 'feedback',
    name: professionalRoutesNames.professionalFeedbackList,
    meta: {
      label: 'Feedback',
      icon: PhListPlus,
      routeTestId: 'professional-feedback-route-btn'
    },
    component: () => import('@/features/feedback/FeedbackList.vue')
  },
  {
    path: 'feedback/:id',
    name: professionalRoutesNames.professionalAddFeedback,
    meta: {
      notRenderInSidebar: true,
      parentName: professionalRoutesNames.professionalFeedbackList
    },
    component: () => import('@/features/feedback/FeedbackAnswers.vue')
  },
  {
    path: 'directory',
    name: professionalRoutesNames.professionalDirectoryList,
    meta: {
      label: 'Directory',
      icon: PhUsers
    },
    component: () => import('@/features/directory/StaffDirectory.vue')
  },
  {
    path: 'students',
    name: professionalRoutesNames.professionalStudents,
    meta: {
      label: 'Students',
      icon: PhStudent
    },
    component: () => import('@/features/students/StudentsList.vue')
  },
  {
    path: 'groups',
    name: professionalRoutesNames.professionalGroups,
    meta: {
      label: 'Groups',
      icon: PhGlobeStand,
      routeTestId: 'professional-groups'
    },
    component: () => import('@/features/groups/GroupsManagement.vue')
  },
  {
    path: 'groups/:id',
    name: professionalRoutesNames.professionalGroupStudents,
    meta: { notRenderInSidebar: true, parentName: professionalRoutesNames.professionalGroupStudents },
    component: () => import('@/features/groups/GroupStudents.vue')
  }
]

export {
  professionalRoutesNames,
  professionalRoutes
}
